import TYPES from './types';

import { IError } from './reducers';

import AddressModel from 'src/model/address.model';
import addressServiceInstance from 'src/services/address/AddressService';

const setIsPending = (isPending: boolean) => {
  return {
    type: TYPES.SET_IS_PENDING,
    payload: isPending ? isPending : false
  };
};

const setError = (error?: IError) => {
  return {
    type: TYPES.SET_ERROR,
    payload: error
      ? error
      : {
          hasFailed: false,
          message: ''
        }
  };
};

const setAddresses = (addresses: AddressModel[]) => {
  return {
    type: TYPES.SET_ADDRESSES,
    payload: addresses
  };
};

const getAddresses = () => {
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    addressServiceInstance
      .getAllAddresses()
      .then(res => {
        dispatch(setAddresses(res));
        dispatch(setIsPending(false));
      })
      .catch(err => {
        console.error(err);
        dispatch(setIsPending(false));
        dispatch(setError(err));
      });
  };
};

export default {
  setError,
  setIsPending,
  setAddresses,
  getAddresses
};
